import React from 'react'
import { Input, Radio } from 'antd'
import { FormInstance } from 'antd/lib/form'
import { twMerge } from 'tailwind-merge'
import { PencilIcon } from '@heroicons/react/24/solid'

import { getCxFromStyles } from 'helpers'
import { User, UserStatus } from 'modules/UsersModule/types'
import type { Error } from 'api'

import { Button } from 'ui-v2'
import Form, { FormItem } from 'ui/Form'

import styles from '../../Account.module.scss'

type Props = {
  user?: User
  saveUserError: Error | null
  handleSubmit: (data: { [key: string]: string }) => void
  renderActions: (form: FormInstance) => JSX.Element
  edit: () => void
  isEdited: boolean
  showActivationModal: () => void
}

const statuses = [
  { value: UserStatus.Inactive, label: 'Inactive' },
  { value: UserStatus.Active, label: 'Active' },
]

const Status: React.FC<Props> = ({
  saveUserError,
  handleSubmit,
  renderActions,
  user,
  edit,
  isEdited,
  showActivationModal,
}) => {
  const cx = getCxFromStyles(styles)

  return user?.status === UserStatus.Unconfirmed ? (
    <Button className={cx('activateBtn')} onClick={showActivationModal}>
      Activate user account
    </Button>
  ) : (
    <section
      className={twMerge(
        'p-2 bg-bg-light rounded-md flex flex-col gap-2 md:gap-4 md:p-6',
        isEdited && 'border border-indigo-300 shadow-xl',
      )}
    >
      {!isEdited && (
        <div className="text-right">
          <Button onClick={edit}>
            <span className="inline-flex items-center gap-2">
              Edit <PencilIcon className="w-4" />
            </span>
          </Button>
        </div>
      )}

      <Form
        errors={saveUserError?.errors || {}}
        onSubmit={handleSubmit}
        initialValues={{
          fakeStatus: 'Status: ' + (statuses.find((item) => item.value === user?.status)?.label || user?.status || ''),
          status: user?.status || '',
        }}
        reinitialize
        className={cx('form')}
      >
        {({ form }): JSX.Element => (
          <>
            {isEdited ? (
              <>
                <FormItem name="status" className={cx('input', 'status')}>
                  <Radio.Group>
                    {statuses.map((status) => (
                      <Radio key={status.value} value={status.value}>
                        {status.label}
                      </Radio>
                    ))}
                  </Radio.Group>
                </FormItem>

                {isEdited && renderActions(form)}
              </>
            ) : (
              <FormItem name="fakeStatus" className={cx('input')} help="">
                <Input size="large" readOnly className={cx('readonly')} value="ddddd" />
              </FormItem>
            )}
          </>
        )}
      </Form>
    </section>
  )
}

export default Status
